import React from "react";

import styles from "./RegisterSteps.module.scss";

interface IProps {
    currentStep: number;
    steps: IStep[];
    onStepClick: (step:number) => void;
}

export interface IStep {
    label: string;
    active?: boolean
}

const RegisterSteps: React.FC<IProps> = (props) => {
  return (
    <div className={styles.RegisterSteps}>
        {props.steps.map((step, index) => (
            <div key={index} className={styles.step + (index === props.currentStep ? " " + styles.active : "")} onClick={() => props.onStepClick(index)}>
                <div className={styles.index}>{index + 1}</div>
                <div className={styles.label}>{step.label}</div>
                {index < props.steps.length - 1 && <div className={styles.line}></div>}
            </div>
        ))}
    </div>
  );
};

export default RegisterSteps;